import axios from 'axios';

export const validateUser = async (params) => {
  const { data } = await axios.post('/users/validate', params);

  return data;
};
